<template>
  <span>
    {{ label }}
    <b-tag v-if="tabValidationHint.errorsCount" rounded :type="tabValidationHint.type">
      {{ tabValidationHint.errorsCount }}
    </b-tag>
  </span>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue"
import { TabValidationHint } from "@/model/ValidationResult"
import { BTag } from "buefy"

export default defineComponent({
  name: "TabHeaderWithHint",
  components: {
    BTag,
  },
  props: {
    label: {
      type: String,
      default: "",
    },
    tabValidationHint: {
      type: Object as PropType<TabValidationHint>,
      default: () => new TabValidationHint(),
    },
  },
})
</script>
